import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import __isEmpty from 'lodash/isEmpty';
import styles from './memoria.module.scss';

export default function Memoria(props) {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <Text text={items?.entradeta} />

            {!__isEmpty(items) &&
                items?.actual?.map((item, index) => (
                    <div key={`memoria-${index}`}>
                        <div className='gapAfterRow'>
                            <Text text={item.any} tag='strong' className={styles.any} />
                            {item.links?.length > 0 && (
                                <ul className={styles.memoria}>
                                    {item.links.map((link, i) => (
                                        <li key={i}>
                                            <a href={link.url} target='_blank' rel='noreferrer'>
                                                {link.text}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                ))}

            <Text text={items?.anteriors} tag='h2' />

            {!__isEmpty(items) &&
                items?.memories?.map((item, index) => (
                    <div key={`notis-memoria-${index}`}>
                        <div>
                            <Text text={item.any} tag='strong' className={styles.any} />
                            {item.links?.length > 0 && (
                                <ul className={styles.memoria}>
                                    {item.links.map((link, i) => (
                                        <li key={`memoria-anterior-${i}`}>
                                            <a href={link.url} target='_blank' rel='noreferrer'>
                                                {link.text}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                ))}
        </>
    );
}
